/**
 * ClusterCard — one row in the wish cluster list
 */

import clsx from 'clsx';
import type { AdminClusterItem, ClusterStatus } from '../types';

const STATUS_STYLES: Record<ClusterStatus, string> = {
  open: 'bg-blue-100 text-blue-800',
  planned: 'bg-yellow-100 text-yellow-800',
  in_progress: 'bg-purple-100 text-purple-800',
  done: 'bg-green-100 text-green-800',
  rejected: 'bg-gray-100 text-gray-500',
};

const STATUS_LABELS: Record<ClusterStatus, string> = {
  open: '开放',
  planned: '已规划',
  in_progress: '进行中',
  done: '已完成',
  rejected: '已拒绝',
};

interface ClusterCardProps {
  cluster: AdminClusterItem;
  selected: boolean;
  onClick: () => void;
}

export function ClusterCard({ cluster, selected, onClick }: ClusterCardProps) {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'w-full text-left px-4 py-3 rounded-lg border transition-all',
        selected
          ? 'border-blue-500 bg-blue-50 shadow-sm'
          : 'border-gray-200 bg-white hover:bg-gray-50'
      )}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-gray-900 truncate">{cluster.title}</p>
          <div className="flex items-center gap-2 mt-1 flex-wrap">
            <span
              className={clsx(
                'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
                STATUS_STYLES[cluster.status]
              )}
            >
              {STATUS_LABELS[cluster.status]}
            </span>
            <span className="text-xs text-gray-400 uppercase">{cluster.language}</span>
          </div>
        </div>
        <span className="inline-flex items-center justify-center min-w-[2rem] px-2 py-0.5 rounded-full text-xs font-bold bg-gray-100 text-gray-700 flex-shrink-0">
          {cluster.wish_count}
        </span>
      </div>
    </button>
  );
}

export { STATUS_STYLES, STATUS_LABELS };
